import { useCallback } from "react";
import { jsonComparer, useMessageToState } from "./useMessageToState";
import { useSelectedZone } from "./useSelection";
import { useTextZoneDashboard } from "./useTextZoneDashboard";

/**
 *
 * @returns the allowed horizontal and vertical alignments that can be done on the selected textZone
 */
export function useAllowedTextZoneAlignments() {
	const zone = useSelectedZone();
	const textZone = eXpress.core.isAnyTextZone(zone) ? zone : undefined;
	const textDashboard = useTextZoneDashboard();

	return useMessageToState({
		name: "useAllowedTextZoneAlignments",
		filterMessage: (message) =>
			eXpress.core.isZoneAffected(message, textZone) ||
			eXpress.core.isSelectedZoneChanged(message),
		getState: useCallback(
			() => ({
				canSetHorizontalAlignmentToNear: textDashboard.canSetHorizontalAlignmentTo(
					textZone,
					eXpress.core.TextAlignment.Near,
				),
				canSetHorizontalAlignmentToCenter: textDashboard.canSetHorizontalAlignmentTo(
					textZone,
					eXpress.core.TextAlignment.Center,
				),
				canSetHorizontalAlignmentToFar: textDashboard.canSetHorizontalAlignmentTo(
					textZone,
					eXpress.core.TextAlignment.Far,
				),
				canSetVerticalAlignmentToNear: textDashboard.canSetVerticalAlignmentTo(
					textZone,
					eXpress.core.TextAlignment.Near,
				),
				canSetVerticalAlignmentToCenter: textDashboard.canSetVerticalAlignmentTo(
					textZone,
					eXpress.core.TextAlignment.Center,
				),
				canSetVerticalAlignmentToFar: textDashboard.canSetVerticalAlignmentTo(
					textZone,
					eXpress.core.TextAlignment.Far,
				),
			}),
			[textZone, textDashboard],
		),
		comparer: jsonComparer,
	});
}
